/**
 * Troubleshooting-mode cohorts (#30994): a dev/support ("troubleshooter") edit would otherwise
 * become the "most recent offer" agents get auto-redirected to, so their creates/updates flag the
 * offer (quote.global.troubleshootingMode — excluded from redirects, hidden from canonical
 * search). Canonical users auto-clear the flag on update.
 *
 * Canonical = the "Agency" umbrella (agency, external sales, and unlicensed agents — per product,
 * the most important to treat as canonical), internal sales, and anyone with a UW permission.
 * Team leads are intentionally NOT blanket-canonical — their status comes from whatever other
 * roles they hold, which this same check already resolves. Service / bare-CanQuote stay troubleshooters.
 */

const UW_SESSION_FLAGS = [
  'canApproveUWReview',
  'canClearUWFormRejections',
  'canViewUWCancelCodes',
  'canSkipOfferUnderwritingRules',
  'canRunRenewalUnderwriting'
];

export const isCanonicalUser = (session) => {
  if (!session) {
    return false;
  }
  return Boolean(
    session.isAgency ||
      session.isExternalSales ||
      session.isUnlicensed ||
      session.isInternalSales ||
      UW_SESSION_FLAGS.some((flag) => session[flag])
  );
};

// Three states: null = armed (canonical user last touched it — cleared, but a later troubleshooter
// edit re-flags it), true = a troubleshooter's edit, false = a troubleshooter who explicitly turned
// it off (stays off on their further edits). Canonical must return null (not false) so it stays
// distinct from that explicit-off — otherwise a troubleshooter editing a canonical-cleared offer
// wouldn't re-flag.
export const computeTroubleshootingMode = ({ isCanonical, checkboxValue }) => {
  if (isCanonical) {
    return null;
  }
  return checkboxValue !== false;
};
